


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import Moment from 'moment';
import resize from 'vue-resize-directive';
import {en, ja} from 'vuejs-datepicker/dist/locale';
import * as Common from '@/agiles/common';

@Component({
  directives: {
    resize,
  },
})
export default class Calendar extends Vue implements Components.IControl {
  @Prop({ default: '' }) public title?: string;
  @Prop({ default: null }) public value?: Date;
  @Prop({ default: false }) public required: boolean;
  @Prop({default:false}) public keyfield: boolean;      
  @Prop({ default: false }) public deletable: boolean;

  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: null }) public nullValue: Date;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop() public tooltip: string;
  @Prop({ default: false }) public month: boolean;
  @Prop({default:null}) public max?: Date;
  @Prop({default:null}) public min?: Date;

  @Prop({ default: false }) public autoEntry: boolean;
  @Prop({default: Common.dateFlags.default}) public dateFlag: Common.dateFlags;

  public isEdit: boolean = true;
  public validator: Components.ControlValidator;
  public deleteVisible: boolean = false;
  created() {
    this.validator = new Components.ControlValidator(this, 'tooltip', this.internalValidate);
    if (this.editor != null) this.editor.addControl(this);
    //初期化
    this.onValueChanged();

    document.body.addEventListener('mousedown',this.onMouseDownOtherElement);
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
    document.body.removeEventListener('mousedown',this.onMouseDownOtherElement);    

    if(this.scrollParent) this.scrollParent.removeEventListener('scroll',this.onOpening);  
  }
  public get displayValue() {
    if (this.month) return this.$api.formatter.formatDateYM(this.value);
    else return this.$api.formatter.formatDate(this.value);
  }
  //カレンダーの日本語辞書
  public get ja(){
    return ja;
  }

  public mounted() {
    if (this.$refs.target){
      const temp = (this.$refs.target as Vue).$children[0] as Vue;
      temp.$on('showCalendar', this.onOpening);
      // console.log('hooked calendar resizer');
    } else {
      // console.log('failed to hook calendar resizer');
    }
  }

  public onMouseDownOtherElement(e : MouseEvent){
    var datepicker = this.$refs.target as Vue;
    if (datepicker && datepicker.$el.contains(e.target as HTMLElement) == false) (datepicker as any).close(false);
  }
  public onCalendarMounted(){
    if (this.$refs.target) this.onOpening();
  }

  public internalValidate(): string {
    if (this.required && this.internalValue == '') {
      return '必須項目です。';
    }
    if(this.value != null){
      const cpValue = this.getDate(this.value);
      if (this.min != null && cpValue < this.getDate(this.min)) {
        if(this.month) return this.min.getFullYear() + "-" + (this.min.getMonth() + 1) + ' 以上の日付を指定してください';
        else return this.min.getFullYear() + "-" + (this.min.getMonth() + 1) + "-" + this.min.getDate() + ' 以上の日付を指定してください';
      }
      if (this.max != null && cpValue > this.getDate(this.max)) {
        if(this.month) return this.max.getFullYear() + "-" + (this.max.getMonth() + 1) + ' 以下の日付を指定してください';
        else return this.max.getFullYear() + "-" + (this.max.getMonth() + 1) + "-" + this.max.getDate() + ' 以下の日付を指定してください';
      }
    }
    return '';
  }
  private getDate(date: Date): Date{
    return new Date(date.getFullYear(),date.getMonth(),date.getDate());
  }

  @Watch('value')
  public onValueChanged() {
    this.deleteVisible = (this.value != this.nullValue) && this.deletable;
  }

  public get internalValue(): string {
    // 現地日付で文字列に変換する
    if (this.value == this.nullValue) return '';

    const temp = Moment(this.value).format('YYYY-MM-DD');
    return temp;
  }

  public set internalValue(value: string) {
    //日付入力モードの場合に値を検証する
    if (this.$refs.target && this.isValidTypedDate() == false) return;
    // console.log(String.format('setvalue={0}' ,value));
    // ロケールでDate型に変換する(0:00 GMT+0900)
    // 下記は9:00 GMT+0900に変換されていたためタイムゾーンで直接補正
    //const temp = value == null ? this.nullValue : Moment(value).toDate();    
    var temp: Date = null;
    if (value != null){
      temp = value as any as Date;      
      //temp = Moment(temp).add(temp.getTimezoneOffset(), 'minutes').toDate();
      temp = temp.getCalendarDate();
    }
    this.$emit('update:value', temp);
    this.$emit('changed');
    this.validator.update();
  }

  public onDelete() {
    (this.$refs.target as any).clearDate();
  }
  public onDropDown(e: any) {
    ((this.$refs.target as Vue).$el.children[0].children[0] as HTMLElement).focus();
    e.preventDefault();
    this.onOpening();
    (this.$refs.target as any).showCalendar();
  }

  public onOpening() {
    //表示位置を右寄せで調整する〜下にスペースがない場合は上に表示したい。
    const input = ((this.$refs.target as Vue).$el.children[0].children[0] as HTMLElement);
    var popupQuery = 'div.vdp-datepicker__calendar';
    const target = this.$refs.target as Vue;
    var popupElements = target.$el.querySelectorAll(popupQuery);
    popupElements.forEach(element => {
      //スクロールした場合のずれを補正
      var scrollParent = this.getScrollParent(input);
      var scrollLeft = scrollParent != null ? scrollParent.scrollLeft:0;
      var scrollTop = scrollParent != null ? scrollParent.scrollTop:0;
      
      if (window.innerHeight > input.getBoundingClientRect().bottom + 223)
        (element as HTMLElement).style.transform = 'translate(' + (input.clientWidth - scrollLeft - 238) + 'px,' + (1- scrollTop) + 'px)';
      else
        (element as HTMLElement).style.transform = 'translate(' + (input.clientWidth - scrollLeft - 238) + 'px,'+ (-input.clientHeight - scrollTop - 223) +'px)';
    });
  }
  public getScrollParent(node: HTMLElement):HTMLElement {
    if (node == null) {
      return null;
    }

    if (node.scrollHeight > node.clientHeight || node.scrollWidth > node.clientWidth) {
      return node;
    } else {
      return this.getScrollParent(node.parentElement);
    }
  }  


  public onMounted(){
     var el = this.inputElement();
      el.onblur = this.onBlur;
      //クリックで自動表示されるのを停止
      el.addEventListener('click',e =>{
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        } , { capture: true });

     this.dateInputVue().$on('closeCalendar',()=>{
      if (this.value) (this.$refs.target as any).setDate(this.value.getTime());
      else (this.$refs.target as any).clearDate();
     });
    //スクロール時に追従させる
    const input = ((this.$refs.target as Vue).$el.children[0].children[0] as HTMLElement);
    this.scrollParent = this.getScrollParent(this.inputElement());
    if(this.scrollParent) this.scrollParent.addEventListener('scroll',this.onOpening);      
  }
  public scrollParent : HTMLElement;

  public inputElement() : HTMLInputElement{
      return (this.$refs.target as Vue).$children[0].$el.children[0] as HTMLInputElement;
  }

  public dateInputVue() : Vue {
    return (this.$refs.target as Vue).$children[0]; 
  }

  public isValidTypedDate() : boolean{
      //テキスト入力されていて無効な場合にfalse
      var input = (this.dateInputVue() as any).typedDate;
      //マウス選択された場合はtypedDateに変更前の情報が残っているので判定除外する。
      if(input && (this.$refs.target as any).isOpen == false) return input.length ==  (this.month ? 7 : 10) && Moment(input, this.month ? "YYYY-MM" : "YYYY-MM-DD",true).isValid();
      else return true;
  }
  public onBlur(arg:any){
    if (this.isValidTypedDate() == false) {
      //無効な状態でフォーカスアウトした場合にリセットする
      ((this.$refs.target as Vue).$children[0] as any).typedDate = null;
      if (this.value) (this.$refs.target as any).setDate(this.value.getTime());
      else (this.$refs.target as any).clearDate();
    }
  }  


  public get internalDateFlag() { return this.dateFlag;}
  public set internalDateFlag(value : Common.dateFlags) {
    this.$emit('update:dateFlag',value);
  }
  public dateFlags():any[] {
    if (this.month)
      return [
      new Common.BindItem(Common.dateFlags.default,'-'),       
      new Common.BindItem(Common.dateFlags.current_month_begin,'今月'),
      new Common.BindItem(Common.dateFlags.previous_month_begin,'先月'),      
      ];
    else
      return [
      new Common.BindItem(Common.dateFlags.default,'-'),
      new Common.BindItem(Common.dateFlags.today,'今日'),
      new Common.BindItem(Common.dateFlags.yesterday,'昨日'),
      new Common.BindItem(Common.dateFlags.current_week_begin,'今週初'),
      new Common.BindItem(Common.dateFlags.current_week_end,'今週末'),                        
      new Common.BindItem(Common.dateFlags.previous_week_begin,'先週初'),
      new Common.BindItem(Common.dateFlags.previous_week_end,'先週末'),        
      new Common.BindItem(Common.dateFlags.current_month_begin,'今月初'),
      new Common.BindItem(Common.dateFlags.current_month_end,'今月末'),                        
      new Common.BindItem(Common.dateFlags.previous_month_begin,'先月初'),
      new Common.BindItem(Common.dateFlags.previous_month_end,'先月末'),          
      new Common.BindItem(Common.dateFlags.one_week_after,'1週後'),      
      new Common.BindItem(Common.dateFlags.two_week_after,'2週後'),      
      new Common.BindItem(Common.dateFlags.three_week_after,'3週後'),                        
      // new Common.BindItem(Common.dateFlags.current_year_begin,'年度初'),
      // new Common.BindItem(Common.dateFlags.current_year_end,'年度末'),                        
      // new Common.BindItem(Common.dateFlags.previous_year_begin,'前年初'),
      // new Common.BindItem(Common.dateFlags.previous_year_end,'前年末'),                
    ];
  }
  
  @Watch('dateFlag')
  public onDateFlagChanged(newValue:Common.dateFlags, oldValue :Common.dateFlags){
    var target = new Date().getCalendarDate();
    var day = target.getDay();
    day = day == 0 ?  6 : day -1; //月曜日を0～日曜日を6に変換する

    if (this.dateFlag == Common.dateFlags.default){
      if (this.deletable) target = this.nullValue;
    }
    if (this.dateFlag == Common.dateFlags.today) {

    } else if (this.dateFlag == Common.dateFlags.yesterday){
      target.setDate(target.getDate()-1);    
    } else if (this.dateFlag == Common.dateFlags.current_month_begin){
      target.setDate(1);      
    } else if (this.dateFlag == Common.dateFlags.current_month_end){
      target.setDate(1);//今月初
      target.setMonth(target.getMonth() + 1);//来月初
      target.setDate(target.getDate()-1);//今月末
    } else if (this.dateFlag == Common.dateFlags.previous_month_begin){
      target.setDate(1);   
      target.setMonth(target.getMonth()-1)   ;
    } else if (this.dateFlag == Common.dateFlags.previous_month_end){
      target.setDate(1);//今月初
      target.setDate(target.getDate()-1);//前月末
    } else if (this.dateFlag == Common.dateFlags.current_week_begin){      
      target.setDate(target.getDate() - day); //月曜日を返す
    } else if (this.dateFlag == Common.dateFlags.current_week_end){      
      target.setDate(target.getDate() - day + 6); //日曜日を返す
    } else if (this.dateFlag == Common.dateFlags.previous_week_begin){      
      target.setDate(target.getDate() - day - 7); //月曜日を返す
    } else if (this.dateFlag == Common.dateFlags.previous_week_end){      
      target.setDate(target.getDate() - day - 1); //日曜日を返す
    } else if (this.dateFlag == Common.dateFlags.one_week_after){      
      target.setDate(target.getDate() +7); //1週間後      
    } else if (this.dateFlag == Common.dateFlags.two_week_after){      
      target.setDate(target.getDate() +14); //2週間後           
    } else if (this.dateFlag == Common.dateFlags.three_week_after){      
      target.setDate(target.getDate() +21); //3週間後        
    }
    this.$emit('update:value', target);
    if (target != this.value) this.$nextTick(()=>this.$emit('changed'));   
  }  

}
